/**
 * Last Visited Products tracker
 * Runs on product pages to persist visited products to localStorage,
 * independent of whether the <last-visited-products> section is rendered.
 * The cart-page section reads from the same storage key to display the list.
 */

(() => {
  const STORAGE_KEY = 'hairgivers_last_visited_products';
  const MAX_STORED = 16;

  const track = () => {
    const productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;

    let product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      console.error('[LastVisitedProductsTracker] Error parsing product JSON:', e);
      return;
    }

    if (!product || !product.handle) return;

    const productData = {
      id: product.id,
      handle: product.handle,
      title: product.title,
      price: product.price,
      compare_at_price: product.compare_at_price,
      featured_image: product.featured_image,
      url: product.url || `/products/${product.handle}`,
      available: product.available,
      variants: product.variants || [],
      tags: product.tags || [],
      timestamp: Date.now()
    };

    let visited = [];
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      visited = stored ? JSON.parse(stored) : [];
      if (!Array.isArray(visited)) visited = [];
    } catch (e) {
      visited = [];
    }

    visited = visited.filter(p => p && p.handle !== productData.handle);
    visited.unshift(productData);
    visited = visited.slice(0, MAX_STORED);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(visited));
    } catch (e) {
      console.error('[LastVisitedProductsTracker] Error saving to localStorage:', e);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', track, { once: true });
  } else {
    track();
  }
})();
